export const onePhoto = (item) => {
  return [
    item.gun?.year_manufactured,
    item.gun?.manufacturer,
    item.gun?.model_verified,
    item.gun?.submodel_verified,
    item.gun?.caliber,
    item.gun?.finish_color,
    "in",
    item.gun?.overall_condition,
    "Condition",
  ]
    .join(" ")
    .trim()
    .split(/ +/)
    .join(" ")
}

export const otherPhotos = (item) => {
  return [
    item.gun?.year_manufactured,
    item.gun?.manufacturer,
    item.gun?.model_verified,
    item.gun?.submodel_verified,
    item.gun?.caliber,
    item.gun?.finish_color,
    "in",
    item.gun?.overall_condition,
    "Condition Image",
  ]
    .join(" ")
    .trim()
    .split(/ +/)
    .join(" ")
}

const placeholderImages = [
  "/images/static/gun-skele1.webp",
  "/images/static/gun-skele2.webp",
  "/images/static/gun-skele3.webp",
]

/**
 * The placeholder a listing shows when it has no servable photo — chosen from
 * the seed (the listing or brand id) so the server-rendered markup and the
 * client's first render agree. Math.random() here was a hydration mismatch:
 * the two renders picked different files, so React kept the server's src and
 * logged a warning on every photo-less listing.
 */
export const getPlaceholderImage = (seed) => {
  const index = Math.abs(Math.trunc(Number(seed) || 0)) % placeholderImages.length

  return placeholderImages[index]
}

/**
 * Only for onError swaps after hydration, where there is no server render to
 * disagree with. Initial renders must use getPlaceholderImage(seed).
 */
export const getRandomPlaceholderImage = () => {
  const randomIndex = Math.floor(Math.random() * placeholderImages.length)
  return placeholderImages[randomIndex]
}
